import { gql } from 'graphql-request'

export const getProtections = gql`
	query GetProtections($token: String) {
		getProtections(limit: 500, nextToken: $token) {
			nextToken
			items {
				vrn
				priority
				context {
					assetVrn
				}
				parentRule {
					sources
				}
				createdTime
			}
		}
	}
`

export const getProtection = gql`
	query getProtection($vrn: String!) {
		getProtection(vrn: $vrn) {
			item {
				vrn
				name
				priority
				pAccountVrn
				productVrn
				userVrn
				version
				activeTimeoutMinutes
				context {
					assetVrn
					heightMeters
					bufferMeters
					centroid {
						type
						coordinates
					}
					bufferGeometry {
						type
						coordinates
					}
					preferences {
						windSpeedUnit
						timezone
					}
				}
				parentRule {
					kind
					logicalKind 
					sources
					rules
				}
				notification {
					... on ProtectionScheduledNotification {
					kind
					schedules {
						weekDays
						timezone
						times
						destinationListVrn
					}
					guidelines
					sendClear
					}
					... on ProtectionImmediateNotification {
					kind
					destinationListVrns
					guidelines
					sendClear
					}
				}
				clearByEndTime
				createdTime
				removedTime
				}
			}
		}
`

export const createProtection = gql`
	mutation CreateProtection($input: CreateProtectionRequest!) {
		createProtection(input: $input) {
			item {
				vrn
				priority
				context {
					assetVrn
					heightMeters
					bufferMeters
				}
				activeTimeoutMinutes
				createdTime
			}
		}
	}
`

export const deleteProtection = gql`
	mutation DeleteProtection($input: DeleteProtectionRequest!) {
		deleteProtection(input: $input) {
			item {
				vrn
				removedTime
			}
		}
	}
`

export const updateProtection = gql`
	mutation UpdateProtection($input: UpdateProtectionRequest!) {
		updateProtection(input: $input) {
			item {
				vrn
				priority
				context {
					assetVrn
					heightMeters
					bufferMeters
				}
				createdTime
			}
		}
	}
`
